export const loadCartProductsModule = {
    
    getCart(cart) {
        this.emit("fetch", cart)
    },

    loadData() {
        this.emit("load")
    },

    completeLoading() {
        this.emit("loadComplete")
    },

    createContent(data) {
        this.emit("create", data)
    },

    showContent() {
        this.emit("show")
    },


    emitError(message = "") {
        console.error("Too less arguments to fulfill fetch request. Please ask the system administrator for help, if this happens more than once.")
        console.error(message);
        this.emit("error", message);
    },

    emitUrlError(message = "") {
        console.error("Too less arguments to fulfill fetch request. Please ask the system administrator for help, if this happens more than once.")
        console.error(message);
        this.emit("urlError", message);
    },


    events: {},
    /**
     * Löst ein Ereignis aus. Dieser Funktion dürfen beliebig viele
     * params übergeben werden, diese werden 1:1 an die Event-Listener
     * durchgereicht.
     *
     * @param {string} eventName
     * @param {*=} params
     */
    emit(eventName, param = null) {
        if (eventName in this.events) {
            for (const f of this.events[eventName]) {
                f(param)
            }
        }

    },
    /**
     * Registriert einen Event-Listener für das Event eventName.
     *
     * @param {string} eventName
     * @param {Function} cb
     */
    on(eventName, cb) {
        // Hier ist die Klammersetzung ganz wichtig!
        if (!(eventName in this.events)) {
            this.events[eventName] = []
        }
        this.events[eventName].push(cb)
        
    }
}


loadCartProductsModule.on("fetch", (cart) => {
    getCart(cart);
})




function getCart(cart) {
    loadCartProductsModule.loadData()
    jQuery.ajax({
        url: cloudmanufaktur.ajaxurl,
        type: 'post',
        data: {
            action: "getCartProducts",
            cart: JSON.stringify(cart)
        },
        error: (data) => {
            console.error(data)
            loadCartProductsModule.emitError("Es gab einen Fehler im Backend.");
        },
        success: function (data) {
            loadCartProductsModule.createContent(data)
            loadCartProductsModule.completeLoading()
        }
    })

}

